import { useContent } from "../context/ContentContext";

export const LoveStory = () => {
  const { content } = useContent();
  return (
    <section
      id="geschichte"
      data-testid="section-love-story"
      className="py-24 md:py-36 bg-sage-50 relative overflow-hidden"
    >
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-5 relative">
            <div className="relative z-10">
              <img
                data-testid="love-story-image"
                src={content.story_image}
                alt="Unsere Liebesgeschichte"
                className="w-full h-[420px] md:h-[560px] object-cover rounded-2xl shadow-xl"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-40 h-40 md:w-56 md:h-56 border-2 border-sage-300 rounded-2xl hidden md:block" />
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-sage-200 rounded-2xl -z-0 hidden md:block" />
          </div>

          <div className="lg:col-span-7">
            <p className="text-sage-500 uppercase tracking-[0.35em] text-xs mb-6">
              {content.story_eyebrow}
            </p>
            <h2
              data-testid="love-story-title"
              className="font-serif text-4xl sm:text-5xl lg:text-6xl text-sage-800 mb-8 leading-tight"
            >
              {content.story_title_prefix}{" "}
              <span className="font-script text-sage-500 text-5xl sm:text-6xl lg:text-7xl">
                {content.story_title_script}
              </span>
            </h2>

            <div className="space-y-5 text-sage-700 text-base md:text-lg leading-relaxed">
              <p data-testid="love-story-p1">{content.story_p1}</p>
              <p data-testid="love-story-p2">{content.story_p2}</p>
              <p data-testid="love-story-p3">{content.story_p3}</p>
            </div>

            <div className="mt-10 flex items-center gap-4">
              <div className="h-px flex-1 bg-sage-300" />
              <span className="font-script text-2xl text-sage-500">für immer</span>
              <div className="h-px flex-1 bg-sage-300" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LoveStory;
